import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from "./Text";
const isTextDataArray = (arr) => {
    return arr.length === 0 || !("children" in arr[0]);
};
export const Quote = ({ data, options }) => {
    if (data.children.length === 0) {
        return null;
    }
    let children;
    if (isTextDataArray(data.children)) {
        children = data.children.map((text) => (_jsx(Text, { data: text, options: options }, text.text)));
    }
    else {
        children = data.children.map((headingChild) => {
            if (!("children" in headingChild) || headingChild.children.length === 0) {
                return null;
            }
            return headingChild.children.map((text) => (_jsx(Text, { data: text, options: options }, text.text)));
        });
    }
    return options?.quote ? (options.quote(data, children)) : children.length === 0 ? null : (_jsx("blockquote", { children: children }));
};
